import React from 'react';

import { Modal as AntdModal } from 'antd';

import {
  ConfigurationDto,
  ConfigurationHistoriqueDto,
  ConfigurationUpdateRequestDto,
} from 'lib_api/lib/api/gen';

import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';

import FormEdition from './FormEdition';
import HistoriqueTable from './HistoriqueTable';
import { useConfigurationMutation } from './useConfigurationMutationHook';

interface ModalModificationProps {
  close: () => void;
  visible: boolean;
  configuration: ConfigurationDto;
}

export default function ModalModification({
  close,
  visible,
  configuration,
}: ModalModificationProps): React.ReactElement {
  const mutation = useConfigurationMutation(configuration, close);
  const [initials, setInitials] = React.useState<ConfigurationUpdateRequestDto>(
    {
      newValue: configuration?.value ?? null,
      newDescription: configuration?.description ?? null,
    },
  );

  const [formKey, setFormKey] = React.useState(0);

  const reinitFormWithSelectedValue = (
    historique: ConfigurationHistoriqueDto,
  ) => {
    setInitials({
      newValue: historique.value,
      newDescription: historique.description,
    });
    setFormKey(prev => prev + 1);
  };

  return (
    <AntdModal
      open={visible}
      onCancel={close}
      footer={null}
      destroyOnClose={true}
      width={BaseModalWidthUtils.largeWidth}
      maskClosable={false}
      aria-labelledby="modal-title"
    >
      <FormEdition
        key={formKey}
        close={close}
        title="Mise à jour de la configuration"
        initialValues={initials}
        isSubmitting={mutation.isPending}
        submit={mutation.mutate}
        readOnly={configuration.readOnly}
        fullName={configuration.fullName}
      />
      <HistoriqueTable
        idCorrelation={configuration.idCorrelation}
        onSelectHistorique={reinitFormWithSelectedValue}
      />
    </AntdModal>
  );
}
